
import { mapState } from "vuex";

import orderDetails from "../../components/reciever/order-details.vue";
export default {
  components: { orderDetails },
  computed: {
    ...mapState("reciever", ["orderDetails", "orderDetailsLoading"])
  }
};
